import { useEffect, useLayoutEffect } from 'react';
/**
 * A hook for avoid warnings due to using `useLayoutEffect` in an SSR app
 * (see https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 * and https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85).
 *
 * @private
 */
export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map